import { render, staticRenderFns } from "./AdminStudentListIndex.vue?vue&type=template&id=a7dd7b86"
import script from "./AdminStudentListIndex.vue?vue&type=script&lang=js"
export * from "./AdminStudentListIndex.vue?vue&type=script&lang=js"
import style0 from "./AdminStudentListIndex.vue?vue&type=style&index=0&id=a7dd7b86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports